<template>
    <div class="kl-locationpicker">
        <div class="kl-locationpicker-control">
            <template v-if="location">
                <vl-pill class="kl-locationpicker-control__pill" tag-name="button" type="button" @click="editLocation"
                         @close="removeLocation" mod-closable>
                    Locatie ingesteld
                </vl-pill>
                <input type="hidden" name="location" v-model="location">
            </template>
            <button type="button" class="kl-locationpicker-control__button" @click.prevent="openModal" v-else>
                <vl-icon class="kl-locationpicker-control__button__icon" icon="location-gps"/>
                <span class="kl-locationpicker-control__button__label">Kies locatie</span>
            </button>
        </div>

        <kl-modal :isOpen="drawZoneActive" :class="{ 'phonesize-modal': useVisibleArea}" @close="cancelModal" :fullscreen="useVisibleArea">
            <template v-slot:modal-header>
                <vl-column class="kl-locationpicker__modal-header">
                    <vl-button type="button" @click="cancelModal" mod-link mod-icon-after icon="cross">
                        <span v-if="useVisibleArea">Sluiten</span>
                    </vl-button>
                </vl-column>
            </template>
            <template v-slot:modal-content>
                <vl-column class="kl-locationpicker__modal-content">
                    <kl-draw-zone-map
                        class="map"
                        v-if="drawZoneActive"
                        name="zone"
                        ref="mapComponentRef"
                        :show-sidebar-title="false"
                        :input-geometries="zones"
                        :auto-confirm-after-each-edit="true"
                        :rules="mapRules"
                        :mod-toggle-fullscreen="false"
                        :mod-show-gps-location-button="true"
                        :disable-reprojection-warning="true"

                        @input="onZonesChanged"

                        :use-sidebar="!useVisibleArea"
                        :use-input-geometries-for-visible-area="useVisibleArea"

                        :show-sidebar-only-for-import="!useVisibleArea"
                        :zone-is-always-selected="!useVisibleArea"
                        :auto-start-create-state="!useVisibleArea"
                        :show-delete-action="!useVisibleArea"
                        :show-import-action="!useVisibleArea"
                        :hide-search-on-import="!useVisibleArea"
                    />
                </vl-column>
            </template>
            <template v-slot:modal-footer>
                <vl-action-group class="kl-locationpicker__modal-footer">
                    <vl-button v-if="!useVisibleArea" type="button" @click="applyZone" mod-large :mod-disabled="applyZoneButtonDisabled">
                        Zoek in deze zone
                    </vl-button>
                    <vl-button v-if="!useVisibleArea" type="button" @click="cancelModal" mod-tertiary mod-large>
                        Annuleren
                    </vl-button>

                    <vl-button v-if="useVisibleArea" type="button" @click="searchOnVisibleArea" class="stretched-button">
                        Zoek in de zichtbare zone
                    </vl-button>
                    <vl-button v-if="useVisibleArea" type="button" @click="cancelModal" mod-tertiary>
                        Annuleren
                    </vl-button>
                </vl-action-group>
            </template>
        </kl-modal>
    </div>
</template>

<script lang="ts" src="./kl-locationpicker.ts">
</script>

<style lang="scss">
@import "./kl-locationpicker.scss";
</style>
